import { useCallback, useEffect, useState } from "react";

export const SHOW_AD_AND_BS_AT_ONCE: string = "showAdAndBsAtOnce";

const useGetShowAdAndBsAtOnce = (): {
  showAdAndBsAtOnce: boolean;
  toggleShowAdAndBsAtOnce: () => void;
} => {
  const [showAdAndBsAtOnce, setShowAdAndBsAtOnce] = useState<boolean>(() => {
    try {
      const storedValue = localStorage.getItem(SHOW_AD_AND_BS_AT_ONCE);
      return storedValue ? JSON.parse(storedValue) : false;
    } catch (e) {
      return false;
    }
  });

  const toggleShowAdAndBsAtOnce = useCallback(() => {
    setShowAdAndBsAtOnce((prev) => !prev);
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(SHOW_AD_AND_BS_AT_ONCE, JSON.stringify(showAdAndBsAtOnce));
    } catch (e) {
      // do nothing
    }
  }, [showAdAndBsAtOnce]);

  return { showAdAndBsAtOnce, toggleShowAdAndBsAtOnce };
};

export default useGetShowAdAndBsAtOnce;
